import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { config } from 'src/app/app.config';

@Injectable({
    providedIn: 'root'
})
export class CustomTranslateLoader implements TranslateLoader {

    path: string;

    constructor(
        private http: HttpClient,
    ) {
    }

    getTranslation(lang: string): Observable<any> {
        if (lang) {
          const apiAddress = `./assets/i18n/${lang}.json`;
          const baseURL = config.baseURL;
          const endpoint = `${baseURL}Language/api/v3/GetByKey?key=${lang}`;
          return new Observable(observer => {
              this.http.get(endpoint).subscribe({
                next: (res: any) => {
                  window.localStorage.setItem('lang', JSON.stringify(res));
                  observer.next(res);
                  observer.complete();
                },
                error: (err) => {
                  console.error('Error fetching language:', err);
                  // observer.error(err); // ควรเรียก observer.error เพื่อให้ caller handle error ได้
                  this.http.get(apiAddress).subscribe({
                    next: (fallbackRes: any) => {
                      window.localStorage.setItem('lang', JSON.stringify(fallbackRes));
                      observer.next(fallbackRes);
                      observer.complete();
                    },
                    error: (fallbackErr) => {
                      console.error('Error fetching fallback language file:', fallbackErr);
                      observer.error(fallbackErr); // แจ้ง error สุดท้าย
                    }
                  });
                }
              });
          });

        }

    }
}